<template>
  <div class="mpartivulars">
    <m-title :titlelist="listitem"></m-title>
    <div class="componentSty_content">
      <span class="el-icon-delete-solid icon" @click="delhuiyuan"></span>
      <div class="planlobby_content">
        <div class="planlobby_content_info">
          <div class="leftbox">
            <!-- <div class="planlobby_content_item">
              <span class="spansty">会员卡号</span>
              <div class="inpsty">
                <m-super-ipt
                  defaultInfo="请填写会员卡号"
                  v-model="iteminfo.sn"
                ></m-super-ipt>
              </div>
            </div>
            <div class="planlobby_content_item">
              <span class="spansty">RFID</span>
              <div class="inpsty">
                <m-super-ipt
                  defaultInfo="请填写RFID号码"
                  v-model="iteminfo.rfid"
                ></m-super-ipt>
              </div>
            </div> -->
            <div class="planlobby_content_item">
              <span class="spansty">车牌号码：</span>
              <div class="inpstyNew">
                {{ iteminfo.plate }}
              </div>
            </div>
            <div class="planlobby_content_item">
              <span class="spansty">车帮号：</span>
              <div class="inpstyNew">
                {{ iteminfo.carhelpno }}
                <!-- <input
                  style="border: none;outline: none;width: 100%;height: 100%; background-color: #f3f4f5;"
                  v-model="iteminfo.carhelpno"
                ></input> -->
              </div>
            </div>
           
            <!-- <div class="planlobby_content_item">
              <span class="spansty">车辆所有人</span>
              <div class="inpsty">
                <m-super-ipt
                  defaultInfo="请填写车辆所有人"
                  v-model="iteminfo.carowner"
                ></m-super-ipt>
              </div>
            </div>
            <div class="planlobby_content_item">
              <span class="spansty">司机姓名</span>
              <div class="inpsty">
                <m-super-ipt
                  defaultInfo="请填写司机姓名"
                  v-model="iteminfo.driverName"
                ></m-super-ipt>
              </div>
            </div>
            <div class="planlobby_content_item">
              <span class="spansty">驾驶证号码</span>
              <div class="inpsty">
                <m-super-ipt
                  defaultInfo="请填写驾驶证号码"
                  v-model="iteminfo.driveingLicencecode"
                ></m-super-ipt>
              </div>
            </div>
            <div class="planlobby_content_item">
              <span class="spansty">挂车证号码</span>
              <div class="inpsty">
                <m-super-ipt
                  defaultInfo="请填写挂车证号码"
                  v-model="iteminfo.hangLicencecode"
                ></m-super-ipt>
              </div>
            </div>
            <div class="planlobby_content_item">
              <span class="spansty">车主手机号码</span>
              <div class="inpsty">
                <m-super-ipt
                  defaultInfo="请填写车主手机号码"
                  v-model="iteminfo.telephone"
                ></m-super-ipt>
              </div>
            </div> -->
            <div class="planlobby_content_item">
              <span class="spansty">海关监管：</span>
              <el-radio-group v-model="iteminfo.iscustoms" disabled>
                <el-radio label="1">监管</el-radio>
                <el-radio label="2">非监管</el-radio>
              </el-radio-group>
            </div>
            <div class="planlobby_content_item">
              <span class="spansty">排放标准：</span>
              <div class="inpstyNew">
                {{ iteminfo.discharge }}
              </div>
              <!-- <div class="inpsty">
                <m-select
                  v-model="iteminfo.discharge"
                  :list="selectletouroptions"
                ></m-select>
              </div> -->
            </div>
            <div class="planlobby_content_item">
              <span class="spansty">备注：</span>
              <div class="inpstyNew">
                {{ iteminfo.mark }}
              </div>
              <!-- <div class="inpsty">
                <input
                  style="border: none;outline: none;width: 100%;height: 100%; background-color: #f3f4f5;"
                  v-model="iteminfo.mark"
                ></input>
              </div> -->
            </div>
          </div>
          <div class="rightbox">
            <!-- 第一条是用来当空白项的 -->
            <div class="planlobby_content_item">
            </div>
            <!-- <div class="planlobby_content_item">
              <span class="spansty">发放时间</span>
              <div class="inpstyNew">
                {{ mydateFormat(iteminfo.gmtCreate) }}
              </div>
            </div>
            <div class="planlobby_content_item">
              <span class="spansty">挂车号码</span>
              <div class="inpsty">
                <m-super-ipt
                  defaultInfo="请填写挂车号码"
                  v-model="iteminfo.hangPlate"
                ></m-super-ipt>
              </div>
            </div>
            <div class="planlobby_content_item">
              <span class="spansty">司机身份证</span>
              <div class="inpsty">
                <m-super-ipt
                  defaultInfo="请填写司机身份证号码"
                  rule="card"
                  v-model="iteminfo.driverCreticard"
                ></m-super-ipt>
              </div>
            </div> -->
            <div class="planlobby_content_item">
              <span class="spansty">车辆识别代号：</span>
              <div class="inpstyNew">
                {{ iteminfo.carLicencecode }}
              </div>
              <!-- <div class="inpsty">
                <m-super-ipt
                  defaultInfo="请填写行车证号码"
                  v-model="iteminfo.carLicencecode"
                ></m-super-ipt>
              </div> -->
            </div>
            <div class="planlobby_content_item">
              <span class="spansty">车辆类型：</span>
              <div class="inpstyNew">
                {{ iteminfo.cartype==='1'?'新能源车':iteminfo.cartype==='2'?'燃油车':'天然气车' }}
              </div>
              <!-- <div class="inpsty">
                <m-select
                  v-model="iteminfo.cartype"
                  :list="cartype"
                ></m-select>
              </div> -->
            </div>
            <div class="planlobby_content_item">
              <span class="spansty">年检有效期：</span>
              <div class="inpstyNew">
                {{ iteminfo.endDate }}
              </div>
            </div>
            <!-- <div class="planlobby_content_item">
              <span class="spansty">车辆类型</span>
              <div class="inpsty">
                <m-select
                  v-model="iteminfo.truckType"
                  :list="selectletcartypeop"
                ></m-select>
              </div>
            </div> -->
            <!-- <div class="planlobby_content_item">
              <span class="spansty">应急联系电话</span>
              <div class="inpsty">
                <m-super-ipt
                  defaultInfo="请填写应急联系电话"
                  v-model="iteminfo.emytelephone"
                ></m-super-ipt>
              </div>
            </div> -->
            <div class="planlobby_content_item">
              <span class="spansty">限定载重：</span>
              <div class="inpstyNew">
                {{ iteminfo.truckTypecode }}
              </div>
              <!-- <div class="inpsty">
                <m-select
                  v-model="iteminfo.truckTypecode"
                  :list="selectastrict"
                ></m-select>
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <div class="cardinfo">
        <div class="planlobby_content_bot">
          <!-- <img-upload
            class="img-upload"
            title="身份证正面"
            v-model="photo.frontOfIdcard"
          />
          <img-upload
            class="img-upload"
            title="驾驶证正面"
            v-model="photo.frontDriverLicense"
          /> -->
          <img-upload
            class="img-upload"
            title="行驶证正面"
            v-model="photo.base64"
          />
          <!-- <img-upload
            class="img-upload"
            title="挂车证正面"
            v-model="photo.frontTrailerPermit"
          />
          <img-upload
            class="img-upload"
            title="排放证明"
            v-model="photo.emissionCertificate"
          /> -->
          <img-upload
            class="img-upload"
            title="行驶证副页正面"
            v-model="photo.backDrivingLicense"
          />
          <img-upload
            class="img-upload"
            title="行驶证副页反面"
            v-model="photo.backDrivingLicenseBack"
          />

          <!-- 身份证正面 -->
          <!-- <div class="content">
            <span class="photo_titile">身份证正面</span>
            <el-image
              v-if="photo.frontOfIdcard"
              style="width: 100%; height: 100%"
              lazy
              :src="photo.frontOfIdcard"
              :preview-src-list="[photo.frontOfIdcard]"
            >
            </el-image>
          </div> -->
          <!-- 驾驶证正面 -->
          <!-- <div class="content">
            <span class="photo_titile">驾驶证正面</span>
            <el-image
              v-if="photo.frontDriverLicense"
              style="width: 100%; height: 100%"
              lazy
              :src="photo.frontDriverLicense"
              :preview-src-list="[photo.frontDriverLicense]"
            >
            </el-image>
          </div> -->

          <!-- 行驶证正面 -->
          <!-- <div class="content">
            <span class="photo_titile">行驶证正面</span>
            <el-image
              v-if="photo.frontDrivingLicense"
              style="width: 100%; height: 100%"
              lazy
              :src="photo.frontDrivingLicense"
              :preview-src-list="[photo.frontDrivingLicense]"
            >
            </el-image>
          </div> -->
          <!-- 挂车证正面 -->
          <!-- <div class="content">
            <span class="photo_titile">挂车证正面</span>
            <el-image
              v-if="photo.frontTrailerPermit"
              style="width: 100%; height: 100%"
              lazy
              :src="photo.frontTrailerPermit"
              :preview-src-list="[photo.frontTrailerPermit]"
            >
            </el-image>
          </div> -->
          <!-- 排放证明 -->
          <!-- <div class="content">
            <span class="photo_titile">排放证明</span>
            <el-image
              v-if="photo.emissionCertificate"
              style="width: 100%; height: 100%"
              lazy
              :src="photo.emissionCertificate"
              :preview-src-list="[photo.emissionCertificate]"
            >
            </el-image>
          </div> -->
        </div>
        <div class="button">
          <!-- <div class="center"> -->
          <button
            class="btn"
            style="background: #F5F6FA; color: #17B6A1"
            @click="jumpPage"
          >
            返回
          </button>

          <button
            class="btn"
            style="background: #f76956 "
            @click="resetPassword"
          >
            重置密码
          </button>

          <button class="btn" @click="returnpage">保存</button>
        <!--  <button
            class="btn"
            style="background: #ff4900"
            @click="membershipcard"
          >
            补卡
          </button>
          <button class="btn" @click="pringcar">打印</button> -->
          <!-- </div> -->
        </div>
      </div>
    </div>
    <pdialog
      :isshowdialog="isshow"
      :againshow="again"
      :infomsgMsg="infomsg"
      @closedialog="closedialog"
    ></pdialog>
  </div>
</template>
<script>
import mTitle from "@/components/mTitle";
import mSelect from "@/components/mSelect";
import mSuperIpt from "@/components/mSuperIpt.vue";
import print_card from "@/plugins/print_card";
import pdialog from "@/components/pdialog.vue";
import ImgUpload from "@/components/Img-upload.vue";
export default {
  name:"addcarlistinfo",
  data() {
    return {
      listitem: [
        { name: "会员管理" },
        { name: "会员列表", path: "/member/memberlist" },
        { name: "详情" },
      ],
      cartype: [{
				val: "新能源车",
				type: "1"
			}, {
				val: "燃油车",
				type: "2"
			},
			{
				val: "天然气车",
				type: "3"
			}],
      selectoptions: [],
      selectletouroptions: [],
      selectletcartypeop: [],
      selectastrict: [],
      iteminfo: {},
      photo: {},
      timeout: null,
      msgid: null,
      isshow: false,
      infomsg: "是否删除当前车辆?",
      again: true,
      clickindex: 1,
      index:1
    };
  },
  created() {
    console.log('图片转换1');
    this.msgid = window.sessionStorage.getItem("infoid");
    this.getList();
    this.getItemInfo();
  },
  components: {
    mTitle,
    mSelect,
    mSuperIpt,
    pdialog,
    mSuperIpt,
    ImgUpload,
  },
  methods: {
    async saveImageToLocalStorage(imageName){
       const res=await this.getBase64Image(imageName)
        return res
    },
    getBase64Image(src) {
        return new Promise(resolve => {
            let xhr = new XMLHttpRequest()
            xhr.open('get', src, true)
            xhr.responseType = 'blob'
            xhr.onload = function () {
                if (this.status == 200) {
                    let blob = this.response
                    let oFileReader = new FileReader()
                    oFileReader.onloadend = function (e) {
                        const base64 = e.target.result
                        resolve(base64)
                    }
                    oFileReader.readAsDataURL(blob)
                }
            }
            xhr.send()
        })
    },
    async getList() {
      const { data: data0 } = await this.$http("api1", "/sys/dic/list", "get", {
        dictionaryType: "与车主关系",
      });
      if (!data0.data) return;
      this.selectoptions = [];
      data0.data.forEach((item) => {
        this.selectoptions.push(item.val);
      });

      const { data: data1 } = await this.$http("api1", "/sys/dic/list", "get", {
        dictionaryType: "排放标准",
      });
      if (!data1.data) return;
      this.selectletouroptions = [];
      data1.data.forEach((item) => {
        this.selectletouroptions.push(item.val);
      });

      const { data: data2 } = await this.$http("api1", "/sys/dic/list", "get", {
        dictionaryType: "车辆类型",
      });
      if (!data2.data) return;
      this.selectletcartypeop = [];
      data2.data.forEach((item) => {
        this.selectletcartypeop.push(item.val);
      });

      const { data: data3 } = await this.$http("api1", "/sys/dic/list", "get", {
        dictionaryType: "限重载重",
      });
      if (!data3.data) return;
      this.selectastrict = [];
      data3.data.forEach((item) => {
        this.selectastrict.push(item.val);
      });
    },
    async getItemInfo() {
      if (!this.msgid) return;
      const { data } = await this.$http(
        "api1",
        `/driver/car/info/${this.msgid}`,
        "get"
      );
      if (!data.car) return;
      this.iteminfo = data.car;
      this.photo = data.carCertificate[0] || {};

      // this.photo.frontDrivingLicense =await this.saveImageToLocalStorage(this.photo.frontDrivingLicense)

    },
    // 删除会员信息
    async closedialog(res) {
      if (res == "cancel") {
        this.infomsg = "是否删除当前会员?";
        this.again = true;
        this.clickindex = 1;
        this.isshow = false;
        return "";
      }
      ++this.clickindex;
      if (this.clickindex == 2) {
        this.infomsg = "请再次确认!";
        this.again = false;
      }
      if (this.clickindex > 2) {
        const { data } = await this.$http(
          "api1",
          "/driver/car/deleteMemberInfo",
          "post",
          {
            plate: this.iteminfo.plate,
          }
        );
        if (data.code != 0) return this.$message.error(data.msg);
        this.$message.success("删除成功");
        this.infomsg = "是否删除当前会员?";
        this.again = true;
        this.clickindex = 1;
        this.isshow = false;
        this.jumpPage();
      }
    },
    delhuiyuan() {
      // clearTimeout(this.timeout)
      // if(this.index==5){
      //   this.index=1;
        this.isshow = true;
      // }
      // ++this.index;
      // this.timeout=setTimeout(() => {
      //   this.index=1;
      // }, 2000);
    },
    pringcar() {
      print_card(this.iteminfo.plate);
    },
    membershipcard() {
      if (!this.iteminfo.id) return this.$message.error("不存在id");
      this.$messageBox
        .confirm(`是否补卡`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(async () => {
          const { data } = await this.$http(
            "api1",
            "/driver/car/fillcardapplication",
            "post",
            {
              id: this.iteminfo.id,
            }
          );
          if (data.code != 0) return this.$message.error(data.msg);
          return this.$message.success("补卡成功");
        })
        .catch((err) => err);
    },
    // 重置密码
    resetPassword() {
      this.$messageBox
        .confirm("此操作将重置当前密码, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(async () => {
          const { data } = await this.$http(
            "api1",
            "/driver/car/driverResetPassword",
            "post",
            { id: this.msgid }
          );
          if (!data || data.msg != "success")
            return this.$message.error("重置密码失败");
          this.$message.success("重置密码成功");
          this.jumpPage();
        })
        .catch((err) => err);
    },
    returnpage() {
      // 会员卡号和rfid号没保存 是因为状态不是正常状态 所以不允许保存 21 0509
      let isok =
        !this.iteminfo.telephone ||
        !this.iteminfo.emytelephone ||
        !this.iteminfo.carowner ||
        !this.iteminfo.driverName ||
        !this.iteminfo.driveingLicencecode ||
        !this.iteminfo.hangLicencecode ||
        !this.iteminfo.hangPlate ||
        !this.iteminfo.driverCreticard ||
        !this.iteminfo.carLicencecode 
      if (isok) return this.$message.error("必填项不能为空");
      clearTimeout(this.timeout);
      const {
        id,
        frontOfIdcard,
        frontDriverLicense,
        frontDrivingLicense,
        backDrivingLicense,
        backDrivingLicenseBack,
        frontTrailerPermit,
        emissionCertificate,
      } = this.photo;
      this.timeout = setTimeout(async (_) => {
        const { data } = await this.$http(
          "api1",
          "/driver/car/updateCar",
          "post",
          {
            ...this.iteminfo,
            carCertificateEntity: {
              id,
              frontOfIdcard,
              frontDriverLicense,
              frontDrivingLicense,
              backDrivingLicenseBack,
              backDrivingLicense,
              frontTrailerPermit,
              emissionCertificate,
            },
          }
        );console.log(data.msg);
        if (data.msg == "修改失败"){
			  return this.$message.error("保存失败");
		}else{
			this.$message.success("保存成功");
			window.sessionStorage.removeItem("infoid");
			this.jumpPage();
		}
      }, 300);
    },
    jumpPage() {
      this.$router.push("/member/memberlist");
    },
  },
};
</script>
<style lang="scss" scoped>
.mpartivulars {
  position: relative;
  height: 100%;
  background: #fff;

  .componentSty_content {
    position: absolute;
    top: 50px;
    bottom: 0;
    width: 100%;
    background: #fff;
    .icon {
      position: absolute;
      right: 10px;
      top: 10px;
      z-index: 999;
      font-size: 20px;
      color: red;
    }
  }

  .planlobby_content {
    position: relative;
    height: 65%;
    width: 100%;
    border-radius: 2px;

    .planlobby_content_info {
      position: absolute;
      z-index: 999;
      width: 70%;
      left: 50%;
      top: 1%;
      bottom: 0;
      transform: translateX(-50%);

      .leftbox,
      .rightbox {
        float: left;
        height: 100%;
        width: 50%;
      }

      .planlobby_content_item {
        height: 10%;
        // font-size: 80%;
        margin-top: 5px;

        .spansty {
          float: left;
          // font-size: 80%;
          box-sizing: border-box;
          width: 35%;
          height: 70%;
          text-align: right;
        }

        .spansty::before,
        .inpstyNew::before {
          content: "";
          display: inline-block;
          height: 100%;
          vertical-align: middle;
        }

        .inpsty,
        .inpstyNew {
          box-sizing: border-box;
          float: right;
          border: none;
          outline: none;
          // font-size: 80%;
          width: 65%;
          height: 70%;
          border-radius: 2px;
          background: #f3f4f5;
        }

        .inpstyNew {
          background: transparent;
        }
      }
    }
  }

  .cardinfo {
    // position: relative;
    // top: 5%;

    height: 35%;
    display: flex;
    flex-direction: column;
    padding-top: 8px;

    .planlobby_content_bot {
      // position: absolute;
      // left: 50%;
      // transform: translateX(-50%);
      // width: 90%;
      // height: 80%;
      display: flex;
      // padding: 0 20px;
      justify-content: space-around;
      padding-left: 20px;
      flex: 1;
      overflow: hidden;

      .img-upload {
        // flex: 1;
        margin-right: 20px;
        height: 100%;
        width: 15%;
      }

      // .content {
      // position: relative;
      // float: left;
      // height: 100%;
      // width: 19%;
      // margin-left: 1%;
      // border-radius: 2px;
      // font-size: 12px;
      // background: #f3f4f5;
      // cursor: pointer;

      // .photo_titile {
      //   position: absolute;
      //   top: -20px;
      //   left: 50%;
      //   transform: translateX(-50%);
      //   color: #868687;
      //   font-size: 80%;
      // }
      // }
    }

    .button {
      // position: absolute;
      // top: 80%;
      // bottom: 0;
      // width: 100%;
      text-align: center;
      height: 60px;
      line-height: 60px;
      flex-shrink: 0;
      // .center {
      // position: absolute;
      // left: 50%;
      // top: 50%;
      // height: 70%;
      // width: 50%;
      // transform: translate(-50%, -50%);

      .btn {
        border: none;
        border-radius: 5px;
        height: 36px;
        width: 100px;
        margin-left: 20px;
        color: #fff;
        background: #17B6A1;
        cursor: pointer;
      }

      // }
    }
  }

  .imgcontent {
    width: 100%;
    height: 600px;
    text-align: center;

    .img {
      width: auto;
      max-width: 100%;
      height: 100%;
    }
  }
}
</style>